import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import Sidebar from "./Account/Sidebar";
import { getDoctorDetails } from "../../redux/Thunk/Doctor/DoctorThunks";

const DoctorLayout = ({ children }) => {
  const isSidebarVisible = useSelector((state) => state.doctor?.isSidebarVisible);
  const doctorDetails = useSelector((state) => state.doctor?.doctorDetails?.doctor);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  // Initialize loggedInDoctors with the primary account if missing
  useEffect(() => {
    const currentToken = localStorage.getItem("token");
    if (doctorDetails && currentToken) {
      const loggedIn = JSON.parse(localStorage.getItem("loggedInDoctors") || "[]");
      if (loggedIn.length === 0) {
        loggedIn.push({
          token: currentToken,
          refreshToken: localStorage.getItem("refreshToken"),
          DID: doctorDetails.DID,
          name: doctorDetails.personalInfo?.name || "",
          surname: doctorDetails.personalInfo?.surname || "",
          clinicName: doctorDetails.personalInfo?.clinicName || doctorDetails.clinicAddress?.premisesName || doctorDetails.ClinicAddress?.premisesName || "",
          address: [
            doctorDetails.clinicAddress?.areaRoad || doctorDetails.ClinicAddress?.areaRoad, 
            doctorDetails.clinicAddress?.city || doctorDetails.ClinicAddress?.city
          ].filter(Boolean).join(", ") || "",
          phoneNumber: doctorDetails.contactNumber,
          isPrimary: true,
          isOperational: true,
          __v: 2,
        });
        localStorage.setItem("loggedInDoctors", JSON.stringify(loggedIn));
      }
    }
  }, [doctorDetails]);

  // Synchronize Redux state with the correct identity for the current route
  useEffect(() => {
    const loggedInDoctors = JSON.parse(localStorage.getItem("loggedInDoctors") || "[]");
    if (loggedInDoctors.length > 0) {
      const primary = loggedInDoctors.find((d) => d.isPrimary);
      const operational = loggedInDoctors.find((d) => d.isOperational) || primary;
      const target = operational || primary;

      // Update Redux state if the currently displayed doctor doesn't match the active operational doctor
      if (doctorDetails?.DID !== target.DID) {
        dispatch(getDoctorDetails());
      }
    }
  }, [pathname, dispatch, doctorDetails?.DID]);

  return (
    <div className={`transition-all duration-500 ease-in-out ${isSidebarVisible ? "md:pl-[96px]" : "md:pl-4"} pl-4 pr-4 pt-4 min-h-screen overflow-x-hidden`}>
      <Sidebar />
      <div className="w-full">
        {children}
      </div>
    </div>
  );
};

export default DoctorLayout;
